import removeAfterEffectsAsset from './v1_0_0/v1_0_0_migration';
import v1_0_1_patch from './v1_0_1/v1_0_1_migration';
import v1_0_2__addAudioAssetVOMetadata, {
  MigrationContext as v1_0_2_MigrationContext,
} from './v1_0_2/v1_0_2_migration';
import { Migration } from './types';

export type MigrationContext = v1_0_2_MigrationContext;

export default [
  removeAfterEffectsAsset,
  v1_0_1_patch,
  v1_0_2__addAudioAssetVOMetadata,
] as const satisfies Migration<any, any>[];
